import React from "react"
import Button from "../../../../components/Button"
import ShareEmail from "../../../../components/ShareEmail"

const FavoriteShare = (props) => {
  return (
    <div style={{ textAlign: "center" }}>
      <ShareEmail slug={props.slug} />
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
          textAlign: "center",
        }}
      >
        <Button action={props.closeModal} classes={["share-cancel-button"]}>
          Close
        </Button>
      </section>
    </div>
  )
}

export default FavoriteShare
